import React, {useState,useEffect} from 'react';
import useReactRouter from 'use-react-router';
import {RouteComponentProps, Link} from 'react-router-dom'//yarn add @types/react-router-dom
import useStyles from './Styles';
import Hidden from '@mui/material/Hidden';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import Looks1Icon from '@mui/icons-material/LooksOne';
import Looks2Icon from '@mui/icons-material/LooksTwo';
import Looks3Icon from '@mui/icons-material/Looks3';
import Looks4Icon from '@mui/icons-material/Looks4';
import Looks5Icon from '@mui/icons-material/Looks5';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import NavButton from './NavButton';
import Title from './Title';
import {Owner} from './Inc';

interface Props {
	owner:Owner,
}

interface RCProps extends RouteComponentProps<{id:string}> {
	
}

const First = (props:Props)=> {
	const classes = useStyles();
    const rcp:RCProps = useReactRouter();
    let p = "p2";
    if( rcp.match.params.id ){
        p = "p" + rcp.match.params.id;
    }
    const [value, setValue] = useState(p);
    const change = (e: React.MouseEvent<HTMLElement>)=>{
        if( e.currentTarget.dataset.id ){
            if( e.currentTarget.dataset.id==="next" || p===e.currentTarget.dataset.id ){
                const elm = document.getElementById(e.currentTarget.dataset.id+"_pos");
                if( elm ){
                    window.scrollTo( 0,elm.offsetTop-50 );
                }
            } else {
                const elm = document.getElementById("contents_pos");
                if( elm ){
                    window.scrollTo( 0,elm.offsetTop-50 );
                }

                p = e.currentTarget.dataset.id;
                rcp.history.push("/first/"+p);
                setValue(p);
            }
        }
    }
    const goBook = ()=>{
        const elm = document.getElementById("book_pos");
        if( elm ){
            window.scrollTo( 0,elm.offsetTop-50 );
        }
    }
    const goArt = ()=>{
        const elm = document.getElementById("art_pos");
        if( elm ){
            window.scrollTo( 0,elm.offsetTop-50 );
        }
    }

    useEffect(()=>{
        if( !rcp.match.params.id ){
            window.scrollTo(0,0);
        }
    });

	return (
		<div className={classes.root}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={8}>
                    <div id="contents_pos"></div>
                    {value==="p2" &&
                    <React.Fragment>
                        <Paper className={classes.paper} id="p2_pos">
                            <Title text="販売までの流れ" icon="store"/>
                            <div className="firstTalk">
                                <p>作家登録から作品登録や納品書発行まで、架空ストアに作品を預けるのに必要な作業はこのSideBで行えます。</p>
                                <p>基本的な流れは<b>「商品登録して、納品書を作成して、郵送で納品」</b>ですが、最初の１回だけ「作家登録」と「事前審査」が必要です。慣れるまでは以下のチャートを参考にしてみて下さい。</p>
                            </div>
                            <div className="wideSteps">
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <div className="stepList">
                                            <div className="stepBox">
                                                <h3 className={classes.stepH3}>1. 会員登録・作家登録</h3>
                                                <div>
                                                    ・連絡先と作家のプロフィールを登録してください。<br/>
                                                    ・登録料や年会費などは一切不要です。<br/>
                                                    ・登録内容はいつでも変更できます。<br/>
                                                </div>
                                                <div className="stepBtn">
                                                    <Link to="/profile" className={classes.linkButton}><Button variant="contained" color="primary" style={{width:"100%"}}>会員登録・作家登録する</Button></Link>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="stepList" id="art_pos">
                                            <div className="stepArrow artArrow">
                                                <ArrowDownwardIcon className={classes.chartDownwardIcon}/>
                                            </div>
                                            <div className="stepBox">
                                                <h3 className={classes.stepH3}>2. 商品を登録</h3>
                                                <div>
                                                    ・商品名や画像等を登録してください。<br/>
                                                    ・過去に納品したことのある商品を再度納品する場合は、あらたに登録する必要はありません。<br/>
                                                </div>
                                                <div className="stepBtn">
                                                    {props.owner.owner_id>0 ? (
                                                    <Link to="/item" className={classes.linkButton}><Button variant="contained" color="primary" style={{width:"100%"}}>商品登録する</Button></Link>
                                                    ):(
                                                    <Button variant="contained" color="primary" style={{width:"100%"}} disabled={true}>商品登録する</Button>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="stepArrow artArrow">
                                                <ArrowDownwardIcon className={classes.chartDownwardIcon}/>
                                            </div>
                                            <div className="stepBox">
                                                <h3 className={classes.stepH3}>3. 事前審査</h3>
                                                <div>
                                                    ・初めて納品する場合には事前審査が必要です。<br/>
                                                    ・事前審査は「作家さんの審査」ですので商品登録の前に行っても構いませんが、商品登録してある場合はその内容も審査の参考にします。<br/>
                                                </div>
                                                <div className="stepBtn">
                                                    <Link to="/first/input" className={classes.linkButton}><Button variant="contained" color="primary" style={{width:"100%"}}>事前審査</Button></Link>
                                                </div>
                                            </div>
                                            <div className="stepArrow artArrow">
                                                <ArrowDownwardIcon className={classes.chartDownwardIcon}/>
                                            </div>
                                            <div className="stepBox">
                                                <h3 className={classes.stepH3}>4. 納品書作成・納品</h3>
                                                <div>
                                                    ・納品書を作成して商品と一緒にお送りください。月１～２回営業の「井の頭倉庫」に持ち込むこともできます。<br/>
                                                    ・ご利用ガイドの「納品のハウツー」を参考に、内容に間違いがないかどうか必ずチェックしてください。<br/>
                                                </div>
                                                <div className="stepBtn">
                                                    {props.owner.owner_id>0 ? (
                                                    <Link to="/letter" className={classes.linkButton}><Button variant="contained" color="primary" style={{width:"100%"}}>納品書を作成する</Button></Link>
                                                    ):(
                                                    <Button variant="contained" color="primary" style={{width:"100%"}} disabled={true}>納品書を作成する</Button>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="stepArrow artArrow">
                                                <ArrowDownwardIcon className={classes.chartDownwardIcon}/>
                                            </div>
                                            <div className="stepBox">
                                                <h3 className={classes.stepH3}>5. 連絡を待つ</h3>
                                                <div>
                                                    ・商品が架空ストアに到着したら、「納品書と商品が届きました」というメールをお送りします。<br/>
                                                    ・原則として到着から１営業日で納品手続きは完了します。手続きが完了しましたら「在庫の登録が完了しました」というメールをお送りしますので、それまでお待ちください。<br/>
                                                </div>
                                            </div>
                                            <div className="stepArrow artArrow">
                                                <ArrowDownwardIcon className={classes.chartDownwardIcon}/>
                                            </div>
                                            <div className="stepBox">
                                                <h3 className={classes.stepH3}>6. 発売日の登録</h3>
                                                <div>
                                                    ・納品手続きが完了したら発売日を設定してください。<br/>
                                                    ・設定できる発売日は翌日以降１週間後までです。<br/>
													・商品ページにパスワードをかけて販売することもできます。<br/>
                                                </div>
												{props.owner.owner_id>0 ? (
                                                <div className="stepBtn">
                                                    <Link to="/plan" className={classes.linkButton}><Button variant="contained" color="primary" style={{width:"100%"}}>発売日を設定する</Button></Link>
													<Divider style={{margin:'0.2em 0'}}/>
													<Link to="/secret" className={classes.linkButton}><Button variant="contained" color="primary" style={{width:"100%"}}>パスワードをかける</Button></Link>
                                                </div>
                                                ):(
                                                <div className="stepBtn">
                                                    <Button variant="contained" color="primary" style={{width:"100%",marginBottom:'0.4em'}} disabled={true}>発売日を設定する</Button>
													<Button variant="contained" color="primary" style={{width:"100%"}} disabled={true}>パスワードをかける</Button>
                                                </div>
                                                )}
                                            </div>

                                        </div>

                                    </Grid>
                                </Grid>
                            </div>
                        </Paper>
                        <div style={{textAlign:"center",marginTop:"3em"}}>
                            <NavButton id="p3" label="次に「納品のハウツー」を見る" type="bottom" onClick={change}/>
                        </div>
                    </React.Fragment>
                    }
                    {value==="p3" &&
                    <div id="p3_pos">
                        <div className={classes.section}>
                            <Paper className={classes.paper}>
                                <Title text="納品のハウツー" icon="store"/>
                                <div className="firstTalk">
                                    <p>納品する際の注意事項をまとめました。このページの内容を参考にして納品の準備を進めましょう！</p>
                                </div>


                                <div className="section">
                                    <Title text="1. まずは納品書を用意しましょう！" size={2}/>
                                    <ul style={{margin:"0",paddingLeft:"1.5em"}}>
                                        <li style={{marginBottom:"1em"}}>納品書は印刷の場合でも手書きの場合でも、必ず「納品書作成」の手続きを行って、納品受付番号を取得して下さい。</li>
                                        <li style={{marginBottom:"1em"}}>納品書は二枚印刷したりPDFファイルを保存するなどして、必ず控えをお手元に残すようにしましょう。万が一のトラブルを避けるためにも重要です。</li>
										<li style={{marginBottom:"1em"}}>納品書は何度でも作り直して構いません。</li>
                                        <li style={{marginBottom:"1em"}}>納品書が同封されていない場合は受付できませんのでお忘れなく！</li>
                                    </ul>
									<div style={{textAlign:'right'}}>
										<Button variant="text" color="primary" component={Link} to='/letter' startIcon={<ArrowForwardIcon/>}>納品書作成</Button>
									</div>

                                </div>

                                <div className="section">
                                    <Title text="2. 商品に商品ＩＤをつけましょう" size={2}/>
                                    <ul style={{margin:"0",paddingLeft:"1.5em"}}>
                                        <li style={{marginBottom:"1em"}}><span className={classes.important}>重要</span>納品書に記載されている「商品ID」を参考に、商品に付箋やテープなどで商品IDを貼付けて下さい。</li>
                                        <li style={{marginBottom:"1em"}}><span className={classes.important}>重要</span>同じ商品IDの商品がたくさんある場合、ぜんぶに商品IDを貼る必要はありません。袋に入れたり紙テープで縛るなどしてまとめてから、商品IDを一つだけ貼って下さい。</li>
										<li style={{marginBottom:"1em"}}><span className={classes.important}>重要</span>書籍の場合は表紙や背表紙を見れば十分に見分けがつきますので、商品IDの貼り付けを省略しても大丈夫です。（表紙で見分けがつかないトリッキーな商品の場合は貼ってください！）</li>
										<li style={{marginBottom:"1em"}}>アクセサリーなどで微妙な違いのバリエーションがある場合は、商品IDをつけ間違えないようにご注意ください。</li>
										<li style={{marginBottom:"1em"}}>商品ID以外の情報（価格や商品名など）は書かなくて大丈夫です。</li>
                                    </ul>
                                </div>

                                <div className="section">
                                    <Title text="3. 画像と個数は合ってますか？" size={2}/>
                                    <ul style={{margin:"0",paddingLeft:"1.5em"}}>
										<li style={{marginBottom:"1em"}}>SideBに登録した商品画像がほかの商品になってたりしてませんか？画像が違っていると納品手続きができない場合があります。</li>
										<li style={{marginBottom:"1em"}}><span className={classes.important}>重要</span>商品画像に複数の商品が写っていると、お客様がほかの商品と間違えて購入してしまう恐れがあります。なるべくその商品だけが写っている画像を用意しましょう。それが難しい場合は商品の紹介文などに画像の説明を必ず書くようにしてください。</li>
										<li style={{marginBottom:"1em"}}>納品して手元に商品が無くなってしまうと画像の撮り直しができないこともあるかと思います。納品前に画像のチェックは必ず行いましょう。</li>
                                        <li style={{marginBottom:"1em"}}>商品の数をもう一度丁寧に数えましょう。納品書に書いた個数と一致していますか？納品書に赤ペンでチェックを入れてみるのも良いですよ。</li>
                                    </ul>
                                </div>

                                <div className="section">
                                    <Title text="4. 商品の梱包は十分ですか？" size={2}/>
                                    <ul style={{margin:"0",paddingLeft:"1.5em"}}>
                                        <li style={{marginBottom:"1em"}}><span className={classes.important}>重要</span>商品が封筒や箱の中で動かないように、いらない紙や梱包材などを詰めて固定しましょう。そうしないと配送時の振動で破損することがあります。振っても音がしないのが理想です。</li>
                                        <li style={{marginBottom:"1em"}}><span className={classes.important}>重要</span>商品一つ一つが小さな箱やケースなどに入っている場合は、ケースの中で商品が動かないように、何か詰めて固定しましょう。そうしないとケースは無傷なのに中で商品が壊れている…という悲劇が起こることがあります。</li>
                                        <li style={{marginBottom:"1em"}}>破損しないで架空ストアに届くことが第一です。架空ストアからお客さんに送る際のことは架空ストアが責任をもって考えますので気にしなくて大丈夫です。</li>
										<li style={{marginBottom:"1em"}}>商品や納品書に香水など強い匂いのするものが吹きかけられていると、ほかの商品に匂いが移る恐れがありますので、そのような行為は控えてください。</li>
                                    </ul>
                                </div>

                                <div className="section">
                                    <Title text="5. 日時指定は不要ですが、追跡番号をお知らせ下さい（郵便・宅配便の場合）" size={2}/>
                                    <ul style={{margin:"0",paddingLeft:"1.5em"}}>
                                        <li style={{marginBottom:"1em"}}><span className={classes.important}>重要</span>発送が済んだら荷物の追跡番号（お問い合わせ番号）をSideBの「納品」に登録して下さい。（スマートレターなど追跡番号がない場合は不要です）</li>
										<li style={{marginBottom:"1em"}}>架空ストアの定休日は火曜日ですが、火曜日を避けて発送したり日時指定をしたりしなくても追跡番号さえ登録していただければこちらで最短で受け取れるように手続きいたします。</li>
                                        <li style={{marginBottom:"1em"}}>配達日時の指定は不要です。選択が必須の場合は最短の日付を選択し、時間帯は「指定なし」にして下さい。</li>
										<li style={{marginBottom:"1em"}}>送り先（架空ストアの住所）は納品書の左下に記載されていますのでそちらをご覧下さい。</li>
                                    </ul>
                                </div>

                                <div className="section">
                                    <Title text="6. 差出人名と住所は書きましたか？（郵便・宅配便の場合）" size={2}/>
                                    <ul style={{margin:"0",paddingLeft:"1.5em"}}>
                                        <li style={{marginBottom:"1em"}}><span className={classes.important}>重要</span>差出人の名前と住所が書かれていないと、住所の間違いや送料の不足などがあった時に、商品が行方不明になる場合があります。必ず記載するようにして下さい。</li>
                                        <li style={{marginBottom:"1em"}}>クリックポスト、レターパック、ゆうパック、宅急便などの、追跡ができる配送方法がオススメです。</li>
                                    </ul>
                                </div>

                                <div className="section">
                                    <Title text="7. 井の頭倉庫の営業日を確認しましたか？（倉庫持ち込みの場合）" size={2}/>
                                    <ul style={{margin:"0",paddingLeft:"1.5em"}}>
                                        <li style={{marginBottom:"1em"}}><span className={classes.important}>重要</span>井の頭倉庫の営業日は月１～２回だけです。<a href="https://store.retro-biz.com/guide/kiosk">こちらのページ</a>で営業日と営業時間をご確認ください。</li>
                                        <li style={{marginBottom:"1em"}}>井の頭倉庫ではとりあえず納品書と商品の個数だけを確認してお預かりします。商品の登録内容等を確認し納品手続きが完了するのは井の頭倉庫の営業終了後になります。</li>
                                    </ul>
									<div style={{textAlign:'right'}}>
										<Button variant="text" color="primary" component="a" href='https://store.retro-biz.com/guide/kiosk' startIcon={<ArrowForwardIcon/>}>井の頭倉庫</Button>
									</div>
                                </div>

                                <div className="section">
                                    <Title text="8. その他" size={2}/>
                                    <ul style={{margin:"0",paddingLeft:"1.5em"}}>
										<li style={{marginBottom:"1em"}}><span className={classes.important}>重要</span>名刺や自己紹介のカードを購入者に届けたい場合は商品一つ一つにあらかじめ同封して下さい。別途お預かりしたものを当店が発送時に同梱することはできません。</li>
                                        <li style={{marginBottom:"1em"}}>当店および当店店員への差し入れ、プレゼント、書籍の献本など納品する商品以外のものは同封しないようにして下さい。</li>
										<li style={{marginBottom:"1em"}}>商品見本は不要です。</li>
                                    </ul>
                                </div>

                                <div className="section">
                                    <Title text="9. 最後に" size={2}/>
                                    <ul style={{margin:"0",paddingLeft:"1.5em"}}>
                                        <li style={{marginBottom:"1em"}}>いったん気持ちを落ち着けて念のためあと一回だけ、何か忘れていないかチェックしましょう。</li>
										<li style={{marginBottom:"1em"}}>納品手続きが完了したら架空ストアからメールが届きます。そこまで来たらあとは発売日を決めるだけで販売開始です。何か事情があって発売日の設定に時間がかかる場合は、あらかじめ架空ストアにご連絡下さい。<br/>（通常は2週間以内に設定してもらえれば大丈夫です）</li>
                                    </ul>
                                </div>

                            </Paper>
                            <div style={{textAlign:"center",marginTop:"3em"}}>
                                <NavButton id="p4" label="次に「売上を受け取る」を見る" type="bottom" onClick={change}/>
                            </div>

                        </div>
                    </div>}
                    {value==="p4" &&
                    <React.Fragment>
                        <Paper className={classes.paper} id="p4_pos">
                            <Title text="売上を受け取る" icon="store"/>
                            <div className="firstTalk">
                                <p>商品の売上は、「支払申請」をすることでご指定の口座に振り込まれます。売上の残高を時々確認して、ご都合に応じて支払申請を行ってください。</p>
                                <p>振込手数料は１回の振込につき<b>ゆうちょ銀行で110円、その他の銀行・金融機関では210円（いずれも税込）</b>です。</p>
                            </div>
                            <div className="steps">
                                <div className="stepList">
                                    <div className="stepBox">
                                        <h3 className={classes.stepH3}>商品の売上を確認</h3>
                                        <div>
                                            ・購入された商品の入金状況や発送日などリアルタイムで確認できます。<br/>
                                            ・入金と発送の両方が済むと売上金の受け取りが可能になります。<br/>
                                        </div>
                                        <div className="stepBtn">
                                            {props.owner.owner_id>0 ? (
                                            <Link to="/sale" className={classes.linkButton}><Button variant="contained" color="primary" style={{width:"100%"}}>売上を確認する</Button></Link>
                                            ):(
                                            <Button variant="contained" color="primary" style={{width:"100%"}} disabled={true}>売上を確認する</Button>
                                            )}
                                        </div>
                                    </div>
                                    <div className="stepArrow">
                                        <ArrowDownwardIcon className={classes.chartDownwardIcon}/><br/>
                                        売上の残高が貯まってきたら
                                    </div>
                                    <div className="stepBox">
                                        <h3 className={classes.stepH3}>支払申請</h3>
                                        <div>
                                            ・売上を受け取るには「支払申請」を行います。いつでも都合の良いタイミングで申請してください。<br/>
                                        </div>
                                        <div className="stepBtn">
                                            {props.owner.owner_id>0 ? (
                                            <Link to="/sale" className={classes.linkButton}><Button variant="contained" color="primary" style={{width:"100%"}}>支払申請する</Button></Link>
                                            ):(
                                            <Button variant="contained" color="primary" style={{width:"100%"}} disabled={true}>支払申請する</Button>
                                            )}
                                        </div>
                                    </div>
                                    <div className="stepArrow">
                                        <div className={classes.chartDownward}>
                                            <ArrowDownwardIcon className={classes.chartDownwardIcon}/><br/>
                                            通常２～３営業日以内
                                        </div>
                                    </div>
                                    <div className="stepBox">
                                        <h3 className={classes.stepH3}>指定の口座に振り込み</h3>
                                        <div>
                                            ・振込口座は、「ゆうちょ」「銀行・信用金庫」が指定できます。<br/>
                                            ・振込手数料が110～210円（税込）かかります。<br/>
                                        </div>
                                    </div>
                                    <div className="stepArrow">
                                        <div className={classes.chartDownward}>
                                            <ArrowDownwardIcon className={classes.chartDownwardIcon}/><br/>
                                        </div>
                                    </div>
                                    <div className="stepBox">
                                        <h3 className={classes.stepH3}>経理や税金の手続き</h3>
                                        <div>
                                            ・売上の振り込みが完了しますと、支払履歴の詳細で領収書や明細のダウンロード（PDF）ができるようになります。<br/>
                                            ・その他に必要な書類がございましたらお気軽にご相談ください。<br/>
                                        </div>
                                        <div className="stepBtn">
                                            {props.owner.owner_id>0 ? (
                                            <Link to="/payment" className={classes.linkButton}><Button variant="contained" color="primary" style={{width:"100%"}}>支払履歴の詳細を見る</Button></Link>
                                            ):(
                                            <Button variant="contained" color="primary" style={{width:"100%"}} disabled={true}>支払履歴の詳細を見る</Button>
                                            )}
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </Paper>
                        <div style={{textAlign:"center",marginTop:"3em"}}>
                            <NavButton id="p4b" label="次に「メール通知を利用する」を見る" type="bottom" onClick={change}/>
                        </div>
                    </React.Fragment>
                    }
                    {value==="p4b" &&
                    <div id="p4b_pos">
                        <div className={classes.section}>
                            <Paper className={classes.paper}>
                                <Title text="メール通知を利用する" icon="store"/>
                                <div className="firstTalk">
                                    <p>売上レポートや完売時のお知らせなどをメールで受け取ることができます。</p>
									<p>会員登録のメールアドレスにお届けしますのでご登録のメールアドレスをご確認の上でご利用ください。<br/>
									メールアドレスはメール通知の「管理情報」欄で確認できます。</p>
                                </div>

                                <div className="section">
                                    <Title text="1. 毎日の売上レポート" size={2}/>
                                    <ul style={{margin:"0",paddingLeft:"1.5em"}}>
                                        <li style={{marginBottom:"1em"}}>24時間以内に売上があったら毎日指定の時間にお知らせします</li>
                                        <li style={{marginBottom:"1em"}}>メールには商品名と売れた個数が記載されます。それより詳しい情報はSideBでご確認下さい。</li>
										<li style={{marginBottom:"1em"}}>売上がなかった場合にはお知らせしません。</li>
                                        <li style={{marginBottom:"1em"}}>ご注文のキャンセルなどにより実際の売上と異なる場合があります。</li>
                                    </ul>
                                </div>

                                <div className="section">
                                    <Title text="2. 先週の売上レポート" size={2}/>
                                    <ul style={{margin:"0",paddingLeft:"1.5em"}}>
                                        <li style={{marginBottom:"1em"}}>前週（月曜日～日曜日）の売上をまとめて毎週月曜日の昼頃にお知らせします</li>
                                        <li style={{marginBottom:"1em"}}>メールには商品名と売れた個数が記載されます。それより詳しい情報はSideBでご確認下さい。</li>
										<li style={{marginBottom:"1em"}}>売上がなかった場合でもお知らせします。</li>
                                        <li style={{marginBottom:"1em"}}>ご注文のキャンセルなどにより実際の売上と異なる場合があります。</li>
                                    </ul>
                                </div>

                                <div className="section">
                                    <Title text="3. 完売のお知らせ" size={2}/>
                                    <ul style={{margin:"0",paddingLeft:"1.5em"}}>
                                        <li style={{marginBottom:"1em"}}>商品が完売したら翌日の午前7時頃にお知らせします</li>
                                        <li style={{marginBottom:"1em"}}>ご注文のキャンセルなどによりメールの送信時点で在庫が復活している場合には送信は中止されます。</li>
                                    </ul>
                                </div>

                                <div className="section">
                                    <Title text="4. 在庫復活のお知らせ" size={2}/>
                                    <ul style={{margin:"0",paddingLeft:"1.5em"}}>
										<li style={{marginBottom:"1em"}}>完売した商品の在庫がキャンセルで復活したら、すぐにお知らせします</li>
										<li style={{marginBottom:"1em"}}>キャンセル時の扱いが「すぐに販売再開します」になっている場合、このメールと入れ違いで再度完売することがあります。</li>
										<li style={{marginBottom:"1em"}}>キャンセル時の扱いが「あとで発売日を設定します」になっている場合、在庫が復活してもストア上の表示は「在庫０」のままですが異常ではありません。</li>
                                    </ul>
                                </div>

                                <div className="section">
                                    <Title text="5. 抽選受付開始のお知らせ" size={2}/>
                                    <ul style={{margin:"0",paddingLeft:"1.5em"}}>
										<li style={{marginBottom:"1em"}}>抽選販売の受付が開始された時にお知らせします。</li>
                                        <li style={{marginBottom:"1em"}}>基本的には「発売日」で設定した通りの日時に開始されますので、うっかり忘れがちな場合などにご利用ください。</li>
                                    </ul>
                                </div>

                                <div className="section">
                                    <Title text="6. 抽選完了のお知らせ" size={2}/>
                                    <ul style={{margin:"0",paddingLeft:"1.5em"}}>
										<li style={{marginBottom:"1em"}}>抽選販売の受付が終了し抽選結果をすべてのお客様に送信し終わったらお知らせします。</li>
                                        <li style={{marginBottom:"1em"}}>抽選に参加したお客様が多い場合は、結果の送信に数十分程度かかることもあります。</li>
    	                            </ul>
                                </div>

                            </Paper>
                            <div style={{textAlign:"center",marginTop:"3em"}}>
								<NavButton id="p5" label="次に「引き取り・販売終了」を見る" type="bottom" onClick={change}/>
                            </div>

                        </div>
                    </div>}
                    {value==="p5" &&
                    <React.Fragment>
                        <Paper className={classes.paper} id="p5_pos">
                            <Title text="引き取り・販売終了" icon="store"/>
                            <div className="firstTalk">
                                <p>販売を終了して商品を引き取りたい場合は「商品引取」を申請してください。当店で在庫の確認後、速やかに返送いたします。</p>
                                <p>また、プロフィール（作家登録）を削除するには、先に「商品引取」と「支払申請（売り上げがある場合）」を済ませてください。</p>
                            </div>

                            <div className="steps">
                                <div className="stepList">
                                    <div className="stepBox">
                                        <h3 className={classes.stepH3}>商品引き取りの申請</h3>
                                        <div>
                                            ・引取り商品はゆうパック等でのお届け、または月１～２回だけ営業している井の頭倉庫でのお渡しとなります。<br/>
                                            ・ゆうパック等の送料は売上残高から差し引きます。足りない場合は着払いです。<br/>
                                        </div>
                                        <div className="stepBtn">
                                            {props.owner.owner_id>0 ? (
                                            <Link to="/takeback" className={classes.linkButton}><Button variant="contained" color="primary" style={{width:"100%"}}>商品引取を申請する</Button></Link>
                                            ):(
                                            <Button variant="contained" color="primary" style={{width:"100%"}} disabled={true}>商品引取を申請する</Button>
                                            )}
                                        </div>
                                    </div>
                                    <div className="stepArrow">
                                        <ArrowDownwardIcon className={classes.chartDownwardIcon}/><br/>
                                        架空ストアのご利用をやめる場合は
                                    </div>

                                    <div className="stepBox">
                                        <h3 className={classes.stepH3}>支払申請</h3>
                                        <div>
                                            ・引き取り商品の到着後に申請してください。<br/>
                                            ・売上残高が０円の場合は支払申請の必要はありません。<br/>
                                        </div>
                                        <div className="stepBtn">
                                            {props.owner.owner_id>0 ? (
                                            <Link to="/payment" className={classes.linkButton}><Button variant="contained" color="primary" style={{width:"100%"}}>支払申請する</Button></Link>
                                            ):(
                                            <Button variant="contained" color="primary" style={{width:"100%"}} disabled={true}>支払申請する</Button>
                                            )}
                                        </div>
                                    </div>
                                    <div className="stepArrow">
                                        <ArrowDownwardIcon className={classes.chartDownwardIcon}/><br/>
                                        通常３営業日以内に振込
                                    </div>

                                    <div className="stepBox">
                                        <h3 className={classes.stepH3}>退会</h3>
                                        <div>
                                            ・今後お客様として買い物をしたい場合は、プロフィール（作家登録）だけ削除して会員登録を残しておくことも可能です。<br/>
                                        </div>
                                        <div className="stepBtn">
                                            {props.owner.owner_id>0 ? (
                                            <Link to="/bye" className={classes.linkButton}><Button variant="contained" color="primary" style={{width:"100%"}}>退会手続きはこちら</Button></Link>
                                            ):(
                                            <Button variant="contained" color="primary" style={{width:"100%"}} disabled={true}>退会手続きはこちら</Button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Paper>
                        <div style={{textAlign:"center",marginTop:"3em"}}>
                            <Link to="/help" className={classes.linkButton}><Button variant="text" color="primary"><ArrowForwardIcon/>さらに「ヘルプ！（詳しい説明）」も見る</Button></Link>
                        </div>
                    </React.Fragment>
                    }
                </Grid>
                <Grid item xs={12} md={4}>
					<Paper className={classes.paper} style={{marginBottom:"1em"}}>
						<Title text="ご利用ガイド" size={2}/>
						<List>
							<ListItem button data-id="p2" onClick={change} style={{padding:'0'}}>
								<ListItemIcon style={{marginRight:'-1em'}}><Looks1Icon/></ListItemIcon>
								<ListItemText primary="販売までの流れ"/>
							</ListItem>
							<ListItem button data-id="p3" onClick={change} style={{padding:'0'}}>
								<ListItemIcon style={{marginRight:'-1em'}}><Looks2Icon/></ListItemIcon>
								<ListItemText primary="納品のハウツー"/>
							</ListItem>
							<ListItem button data-id="p4" onClick={change} style={{padding:'0'}}>
								<ListItemIcon style={{marginRight:'-1em'}}><Looks3Icon/></ListItemIcon>
								<ListItemText primary="売上を受け取る"/>
							</ListItem>
							<ListItem button data-id="p4b" onClick={change} style={{padding:'0'}}>
								<ListItemIcon style={{marginRight:'-1em'}}><Looks4Icon/></ListItemIcon>
								<ListItemText primary="メール通知を利用する"/>
							</ListItem>
							<ListItem button data-id="p5" onClick={change} style={{padding:'0'}}>
								<ListItemIcon style={{marginRight:'-1em'}}><Looks5Icon/></ListItemIcon>
								<ListItemText primary="引き取り・販売終了"/>
							</ListItem>
						</List>
						<FormControl fullWidth={true}>
							<Link to="/help" style={{textAlign:'right'}}>
								<Button variant="text" color="primary" style={{marginBottom:"0.5em",textAlign:'right'}}><ArrowForwardIcon style={{marginRight:'0.5em'}}/>もっと詳しい説明を見る</Button>
							</Link>
						</FormControl>
					</Paper>

                    <Paper className={classes.paper} id="next_pos">
                        <Title text="次はどうする？" size={2}/>
                        <List
							dense
							style={{marginBottom:'1em'}}
                        >
							<ListItem style={{marginLeft:'-1em'}}>
								<ListItemIcon style={{marginRight:"-1em"}}><TipsAndUpdatesIcon color="primary"/></ListItemIcon>
								<ListItemText primary="試しに登録してみたい"/>
							</ListItem>
                            <Link to="/profile" className={classes.linkButton}><ListItem button disabled={props.owner.owner_id>0}>
                                <ListItemText primary="会員登録・作家登録"/>
								<ListItemSecondaryAction style={{paddingTop:'0.25em'}}><ArrowForwardIcon/></ListItemSecondaryAction>
                            </ListItem></Link>
                            {props.owner.owner_id>0 &&
                            <Link to="/item" className={classes.linkButton}><ListItem button>
                                <ListItemText primary="商品登録（雑貨）"/>
								<ListItemSecondaryAction style={{paddingTop:'0.25em'}}><ArrowForwardIcon/></ListItemSecondaryAction>
                            </ListItem></Link>
                            }
                            <ListItem><div className={classes.hintFirst}>
                                ※すべて無料でお試しいただけます。<br/>
                                ※作家登録が済むと、商品登録などの機能が利用可能になります。<br/>
								</div></ListItem>
							<ListItem><Divider style={{margin:'1em 0'}}/></ListItem>
							<ListItem style={{marginLeft:'-1em'}}>
								<ListItemIcon style={{marginRight:"-1em"}}><TipsAndUpdatesIcon color="primary"/></ListItemIcon>
								<ListItemText primary="作品を納品したい"/>
							</ListItem>
                            <Link to="/first/input" className={classes.linkButton}><ListItem button>
                                <ListItemText primary="事前審査"/>
								<ListItemSecondaryAction style={{paddingTop:'0.25em'}}><ArrowForwardIcon/></ListItemSecondaryAction>
                            </ListItem></Link>
                            <ListItem><div className={classes.hintFirst}>
                                ※初回の納品前に審査が必要です。<br/>
                                ※２回目以降の納品（１回目と違う商品でも）に審査は必要ありません。<br/>
                            </div></ListItem>
							<ListItem><Divider style={{margin:'1em 0'}}/></ListItem>
							<ListItem style={{marginLeft:'-1em'}}>
								<ListItemIcon style={{marginRight:"-1em"}}><TipsAndUpdatesIcon color="primary"/></ListItemIcon>
								<ListItemText primary="さらに詳しく知りたい"/>
							</ListItem>
                            <Link to="/help" className={classes.linkButton}><ListItem button>
                                <ListItemText primary="ヘルプ！（詳しい説明）"/>
								<ListItemSecondaryAction style={{paddingTop:'0.25em'}}><ArrowForwardIcon/></ListItemSecondaryAction>
                            </ListItem></Link>
							<ListItem><Divider style={{margin:'1em 0'}}/></ListItem>
							<ListItem style={{marginLeft:'-1em'}}>
								<ListItemIcon style={{marginRight:"-1em"}}><TipsAndUpdatesIcon color="primary"/></ListItemIcon>
								<ListItemText primary="メールで質問したい"/>
							</ListItem>
                            <Link to="/inquiry" className={classes.linkButton}><ListItem button>
                                <ListItemText primary="お問い合わせ"/>
								<ListItemSecondaryAction style={{paddingTop:'0.25em'}}><ArrowForwardIcon/></ListItemSecondaryAction>
                            </ListItem></Link>
                        </List>
                    </Paper>
                </Grid>
            </Grid>
		</div>
	);
}

export default First;
